import React from 'react';
import Inicio from './Pages/Inicio'


function App() {
  return (
    <div >
      <Inicio/>
    </div>
  );
}

export default App;
